import { useLocation } from 'react-router-dom';

import { LocationState } from 'src/hooks/useLoginToParams';
import { useQueryStringParam } from 'src/hooks/useQueryStringParam';
import { SearchParamKnownKeys } from 'src/hooks/useUrlSearchParams';

import { sanitizeReturnTo } from 'src/urls/sanitizeReturnTo';

/**
 * Hook to get and validate the redirect URL
 *
 * This hook retrieves a redirect URL from either query parameters or location state,
 * then validates it to prevent open redirect vulnerabilities.
 *
 * @returns A validated redirect URL or the base URL if validation fails
 */
const useReturnTo = (defaultReturnTo?: string): string => {
  const location = useLocation<LocationState>();
  const qs = useQueryStringParam(SearchParamKnownKeys.RETURN_TO);
  const returnTo = qs || location.state?.redirectUrl;
  return sanitizeReturnTo(returnTo, { defaultReturnTo });
};

export default useReturnTo;
